export const reduxKey = '@@FBS';
export const IDENTITY_STREAM_ID = `${reduxKey}:IDENTITY`;
export const PROMOTIONS_STREAM_ID = `${reduxKey}:drawer:promotions`;
export const MESSAGE_SEEN_TIMEOUT = 1000;
export const MAX_FETCH_FAILURES = 3;
export const MINIMUM_DEVIATIONS_IN_NOTIFICATION_STRIPS = 3;
export const USER_FEED_BUCKET = 'bucket.user_feed_all';
export const GROUP_FEED_BUCKET = 'bucket.group_feed_all';
export const REPLY_FILTERID = 6;
export const COMMENT_FILTERID = 3;
export const replyFocusableTypes = ['nc.comment', 'nc.replied'];
